import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask1800To1899Service {

  constructor() { }
}
